import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "react-tooltip";
import { handleTooltip } from "../../utils/handleToolTip";
import "./sectionContainer.scss";

function SectionContainer({
  toolTip = "",
  rootClassName = "",
  customStyles = "",
  toolTipId = "section-container-tooltip",
  ...props
}) {
  toolTip = handleTooltip(toolTip);
  const h5Styles = { ...styles.title, ...props.style };

  return (
    <div className={rootClassName} data-testid="section-container-root">
      <span className={"section-container " + customStyles}>
        {props.title && (
          <h5
            data-testid={props.title}
            data-tooltip-id={toolTipId}
            data-tooltip-html={toolTip}
            style={h5Styles}
            className="dashboardModuleSectionContainer"
          >
            {props.title}
          </h5>
        )}
        <div className="dashboardModuleSectionBody" data-testid="section-container-children">
          {props.children}
        </div>
      </span>
      {props.toolTipId && <Tooltip id={toolTipId} />}
    </div>
  );
}

SectionContainer.propTypes = {
  children: PropTypes.any,
  title: PropTypes.string,
  customStyles: PropTypes.string,
  toolTip: PropTypes.string,
  style: PropTypes.object,
  rootClassName: PropTypes.string,
  isToolTipHtml: PropTypes.bool,
  toolTipId: PropTypes.string
};

const styles = {
  title: {
    padding: 0,
    marginTop: 0,
    marginLeft: 0,
    marginRight: 0,
    marginBottom: 13,
    textTransform: "uppercase",
    fontWeight: 700
  }
};

export default SectionContainer;
